// extracted by mini-css-extract-plugin
export default {"search_container":"order_search_container__i8ou0"};